import { LazyImage } from '@components/common/image'
import Logo from '@components/common/logo'
import BookTrialClassContainer from '@containers/book-trial-class/book-trial-class-container'

const FirstFold = () => (
  <div
    className="relative lg:m-3 h-full rounded-b-none md:rounded-lg p-2 lg:p-0 lg:rounded-2xl footer-primary-gradient lg:py-10"
    id="firstFold"
  >
    <Logo
      withText
      whiteText
      className="h-8 lg:w-40 mt-2 lg:-mt-5 lg:h-12 lg:ml-20"
      alt="Codingal logo"
    />
    <div className="flex flex-col lg:px-24 lg:flex-row items-center justify-center lg:space-x-24">
      <div className="w-full md:w-128">
        <h1 className="text-white font-700 text-3xl md:text-5xl text-center lg:text-left leading-tight mt-4 md:mt-10 lg:mt-12">
          Learn problem-solving and analytical thinking through coding
        </h1>
        <h2 className="text-white text-xl md:text-2xl text-center lg:text-left py-4">
          Book your free coding class now
        </h2>
        <div className="hidden lg:block mt-10 -mb-20">
          <LazyImage
            path="/images/benefits-of-coding/first-fold/"
            className="w-128"
            name="kid-with-laptop"
            alt="Boy working on laptop"
          />
        </div>
      </div>

      <div className="z-10 mt-4 lg:mt-0">
        <BookTrialClassContainer />
      </div>
    </div>
  </div>
)

export default FirstFold
